export const HighlightedCell = (props) => {
  const data = props.value;

  return (
    <>
      {data ? <span className="android-plugins__highlighted-cell">{data}</span> : <span>None</span>}
    </>
  );
};
